(function () {
  'use strict';
  var CFG = window.HDBWishlist || {};
  var KEY = 'hdb_wishlist_v1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var STR = CFG.strings || {};
  var MONEY = CFG.moneyFormat || '\u20ac{{amount}}';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hdb:wishlist:change', { detail: { list: list } }));
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(); var i = list.indexOf(h);
    if (i === -1) { list.push(h); } else { list.splice(i, 1); }
    write(list); return i === -1;
  }
  function count() { return read().length; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var HEART_PATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
  function heart() {
    return '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="' + HEART_PATH + '"/></svg>';
  }
  function headerSvg() {
    return '<svg class="hdb-wishlist-svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">' +
      '<path class="hdb-heart" d="' + HEART_PATH + '" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<g class="hdb-badge" style="display:none">' +
      '<circle cx="19" cy="6" r="7.4" fill="#d64550"/>' +
      '<text class="hdb-badge-count" x="19" y="6.3" text-anchor="middle" dominant-baseline="central" font-size="11.5" font-weight="700" fill="#fff" font-family="-apple-system, Helvetica, Arial, sans-serif">0</text>' +
      '</g></svg>';
  }
  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function money(cents) {
    cents = (typeof cents === 'number') ? cents : (parseInt(cents, 10) || 0);
    var fmt = MONEY || '\u20ac{{amount}}';
    function n(prec, th, dec) {
      var s = (cents / 100).toFixed(prec); var p = s.split('.');
      var whole = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? whole + dec + p[1] : whole;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, t) {
      switch (t) {
        case 'amount_no_decimals': return n(0, '.', ',');
        case 'amount_with_comma_separator': return n(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return n(0, '.', ',');
        case 'amount_with_apostrophe_separator': return n(2, "'", '.');
        default: return n(2, ',', '.');
      }
    }).replace(/&nbsp;/g, ' ').replace(/<[^>]*>/g, '').trim();
  }

  function setState(btn, active) {
    btn.classList.toggle('is-active', active);
    if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? (STR.remove || '') : (STR.add || ''));
    var lbl = btn.querySelector('.hdb-wishlist-label');
    if (lbl) lbl.textContent = active ? (STR.saved || STR.remove || '') : (STR.add || '');
  }

  function cardButton(handle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hdb-wishlist-btn hdb-wishlist-card-btn' + (has(handle) ? ' is-active' : '');
    b.setAttribute('data-hdb-wishlist', handle);
    b.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    b.setAttribute('aria-label', has(handle) ? (STR.remove || '') : (STR.add || ''));
    b.innerHTML = heart();
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var added = toggle(handle);
      setState(b, added);
      b.classList.remove('hdb-pop'); void b.offsetWidth; b.classList.add('hdb-pop');
    });
    return b;
  }

  function injectCards(scope) {
    (scope || document).querySelectorAll('.card-wrapper:not([data-hdb-done])').forEach(function (cardEl) {
      var link = cardEl.querySelector('a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle) { return; }
      cardEl.setAttribute('data-hdb-done', '1');
      cardEl.classList.add('hdb-wishlist-anchor');
      cardEl.appendChild(cardButton(handle));
    });
  }

  function injectProduct() {
    var handle = handleFromUrl(location.pathname);
    if (!handle) return;
    if (document.querySelector('.hdb-wishlist-product-btn')) return;
    var title = document.querySelector('.product__title');
    var buy = document.querySelector('.product-form__buttons');
    var info = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
    if (!title && !buy && !info) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hdb-wishlist-btn hdb-wishlist-product-btn' + (has(handle) ? ' is-active' : '');
    b.setAttribute('data-hdb-wishlist', handle);
    b.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    b.innerHTML = heart() + '<span class="hdb-wishlist-label">' + esc(has(handle) ? (STR.saved || STR.remove || '') : (STR.add || '')) + '</span>';
    b.addEventListener('click', function () { setState(b, toggle(handle)); });
    if (buy && buy.parentNode) buy.parentNode.insertBefore(b, buy.nextSibling);
    else if (title && title.parentNode) title.parentNode.insertBefore(b, title.nextSibling);
    else info.appendChild(b);
  }

  function injectHeader() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.hdb-wishlist-header')) return;
    var a = document.createElement('a');
    a.href = root + 'pages/favorieten';
    a.className = 'header__icon header__icon--wishlist hdb-wishlist-header link focus-inset';
    a.setAttribute('aria-label', STR.headerLabel || 'Favorites');
    a.innerHTML = headerSvg();
    var cart = icons.querySelector('a[href*="/cart"]');
    if (cart) icons.insertBefore(a, cart); else icons.appendChild(a);
  }

  function updateCount() {
    var c = count();
    document.querySelectorAll('.hdb-wishlist-header').forEach(function (link) {
      var badge = link.querySelector('.hdb-badge');
      var txt = link.querySelector('.hdb-badge-count');
      if (txt) txt.textContent = String(c);
      if (badge) badge.style.display = c > 0 ? '' : 'none';
      link.classList.toggle('is-active', c > 0);
    });
  }

  function refresh() {
    document.querySelectorAll('[data-hdb-wishlist]').forEach(function (b) {
      setState(b, has(b.getAttribute('data-hdb-wishlist')));
    });
  }

  function card(p, handle) {
    var url = root + 'products/' + handle;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var el = document.createElement('div');
    el.className = 'hdb-wishlist-item';
    el.setAttribute('role', 'listitem');
    el.innerHTML =
      '<a class="hdb-wishlist-item__media" href="' + url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + esc(p.title) + '">' : '') + '</a>' +
      '<div class="hdb-wishlist-item__info">' +
      '<a class="hdb-wishlist-item__title" href="' + url + '">' + esc(p.title) + '</a>' +
      '<div class="hdb-wishlist-item__price">' + money(p.price) + '</div>' +
      '</div>' +
      '<button type="button" class="hdb-wishlist-item__remove" aria-label="' + esc(STR.remove || '') + '">&times;</button>';
    el.querySelector('.hdb-wishlist-item__remove').addEventListener('click', function () {
      toggle(handle);
      if (el.parentNode) el.parentNode.removeChild(el);
      if (!read().length) renderPage();
    });
    return el;
  }

  function renderPage() {
    var grid = document.getElementById('hdb-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('hdb-wishlist-empty');
    var loading = document.getElementById('hdb-wishlist-loading');
    var handles = read();
    grid.innerHTML = '';
    function showEmpty() {
      if (loading) loading.hidden = true;
      if (empty) {
        empty.innerHTML = '<p>' + esc(STR.empty || '') + '</p><a class="button" href="' + root + 'collections/all">' + esc(STR.emptyCta || '') + '</a>';
        empty.hidden = false;
      }
    }
    if (!handles.length) { showEmpty(); return; }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      if (loading) loading.hidden = true;
      var any = false;
      products.forEach(function (p, i) { if (p) { any = true; grid.appendChild(card(p, handles[i])); } });
      if (!any) showEmpty();
    });
  }

  var observer;
  function observe() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { injectCards(document); break; } }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function run() {
    injectHeader();
    injectCards(document);
    injectProduct();
    updateCount();
    renderPage();
    observe();
  }

  document.addEventListener('hdb:wishlist:change', function () { updateCount(); refresh(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { updateCount(); refresh(); renderPage(); } });
  document.addEventListener('shopify:section:load', function () { injectHeader(); injectCards(document); injectProduct(); updateCount(); renderPage(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  window.HDBWishlist = window.HDBWishlist || {};
  window.HDBWishlist.toggle = toggle;
  window.HDBWishlist.has = has;
  window.HDBWishlist.list = read;
  window.HDBWishlist.count = count;
})();
